import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import images from "../../../utilities/images/images";
import { postAdaptiveSubTopicListRequest } from "../../../redux/adaptive_qbank/adaptiveQBankSlice";
import "./AdaptiveQuestionBankSubtopicProgress.css";

const getStatusMeta = (status = "") => {
  const normalized = String(status).toLowerCase();
  if (normalized.includes("complete") || normalized.includes("master")) {
    return { className: "mastered", showIcon: true };
  }
  if (normalized.includes("practic")) {
    return { className: "practicing", showIcon: false };
  }
  return { className: "default", showIcon: false };
};

const AdaptiveQuestionBankSubtopicProgress = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedTopic = location.state?.topic || null;
  const subjectName = location.state?.subject || "";

  const { subTopicList, loading, error } = useSelector(
    (state) => state.adaptiveQBank
  );

  useEffect(() => {
    if (!selectedTopic?.topic_id) return;
    dispatch(
      postAdaptiveSubTopicListRequest({
        topic_id: selectedTopic.topic_id,
        subject: subjectName,
      })
    );
  }, [dispatch, selectedTopic, subjectName]);

  const subtopics = useMemo(() => {
    const data = subTopicList?.data || subTopicList || {};
    return (
      data?.subtopic_list ||
      data?.subtopics ||
      data?.sub_topic ||
      data?.topic_subtopics ||
      []
    );
  }, [subTopicList]);

  return (
    <div className="aqb-subtopic-page">
      <div className="aqb-subtopic-header">
        <img
          src={images.new_backarrow}
          alt="Back"
          className="aqb-subtopic-back"
          onClick={() => history.push("/practice/adaptive-question-bank/next-focus-set")}
        />
        <h3 className="aqb-subtopic-title">
          {selectedTopic?.topic_name || "Adaptive Question Bank"}
        </h3>
      </div>

      <div className="aqb-subtopic-section-title">Your Subtopic Progress</div>

      {loading?.subTopicList ? (
        <div className="aqb-subtopic-state">Loading subtopics...</div>
      ) : null}
      {!loading?.subTopicList && error ? (
        <div className="aqb-subtopic-state">Unable to load subtopics.</div>
      ) : null}
      {!loading?.subTopicList && !error && !subtopics.length ? (
        <div className="aqb-subtopic-state">No subtopics found.</div>
      ) : null}

      {!loading?.subTopicList && !error && subtopics.length > 0 ? (
        <div className="aqb-subtopic-grid">
          {subtopics.map((item, idx) => {
            const statusText =
              item?.subtopic_status ||
              item?.ui_status ||
              item?.topic_status ||
              item?.status ||
              "Not Visited";
            const statusMeta = getStatusMeta(statusText);
            return (
              <div
                className="aqb-subtopic-card"
                key={item?.subtopic_id || item?.["sub_topic_id"] || idx}
              >
                <div className="aqb-subtopic-name">
                  {item?.subtopic_name ||
                    item?.["sub topic name"] ||
                    item?.sub_topic_name ||
                    item?.name ||
                    "Subtopic"}
                </div>
                <div className="aqb-subtopic-level">
                  {item?.subtopic_level ||
                    item?.mastery_tag ||
                    item?.level ||
                    "Medium Mastery"}
                </div>
                <span className={`aqb-subtopic-status ${statusMeta.className}`}>
                  {statusMeta.showIcon ? (
                    <img
                      src={images.topic_status_icon}
                      alt=""
                      className="aqb-subtopic-status-icon"
                    />
                  ) : null}
                  {statusText}
                </span>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default AdaptiveQuestionBankSubtopicProgress;
